import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Pregunta } from '../../models/pregunta.model';
import { Opcion } from '../../models/opcion.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-pregunta-item',
  templateUrl: './pregunta-item.component.html',
  styleUrl: './pregunta-item.component.scss'
})
export class PreguntaItemComponent {

  @Input() pregunta?: Pregunta;
  @Output() preguntaChange = new EventEmitter<Pregunta>();

  public respuestaTexto: string = '';
  public answerMaxLength: number = environment.limits.answerMaxLength;

  onRespuestaTextoChange(event: any) {

    console.log(event);
    

    if(this.pregunta) {

      if(!this.pregunta.respuesta) {
        this.pregunta.respuesta = new Opcion({
          idPregunta: this.pregunta.idPregunta,
          respuesta: this.respuestaTexto,
          permiteTexto: true,
          preguntas: []
        });
      } else {
        this.pregunta.respuesta.respuestaTexto = this.respuestaTexto;
      }
    }
  }

}
